import { TypedDocumentNode } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import { AdminPracticeFilesQueryDocument } from '@docpace/admin-graphql/dist/urql.types'
import { AdminPracticeFilesQueryResultFragment } from '@docpace/admin-graphql'

const typedAdminPracticeFilesQueryDocument = AdminPracticeFilesQueryDocument as TypedDocumentNode<AdminPracticeFilesQueryResultFragment>

export function useAdminPracticeFilesQuery(opts?: useQuery.Options<AdminPracticeFilesQueryResultFragment>){
    return useQuery(typedAdminPracticeFilesQueryDocument, opts)
}
